import {Utils} from '../../common/scripts/utils';

class Stock {
    constructor(options) {
        this.wrapper = options.wrapper;

        this.isVisible = false;
    }

    init() {
        this._initElements();

        this._bindEvents();
    }

    _initElements() {
        this.dropdownBtn = this.wrapper.querySelector('.j-surprise-btn');
        this.dropdown = this.wrapper.querySelector('.j-surprise-dropdown');
        this.header = document.querySelector('.j-header') || null;

        this.bindedClose = this._closeDropdown.bind(this);
    }

    _bindEvents() {
        if (!this.dropdownBtn && !this.dropdown && Boolean(Utils.isMobile())) {
            return;
        }

        this.dropdownBtn.addEventListener('click', (event) => {
            event.stopPropagation();
            this.isVisible ? this._closeDropdown() : this._openDropdown();
            document.addEventListener('click', this.bindedClose);
            document.addEventListener('scroll', this._closeDropdown.bind(this));
        });
    }

    /**
     * Раскрываем список
     */
    _openDropdown() {
        this.headerHeight = this.header?.offsetHeight || 85;
        this.isVisible = true;
        this.dropdown.classList.add('is-visible');

        if (this.dropdown.getBoundingClientRect().top < (this.headerHeight + 10)) {
            this.dropdown.classList.add('is-bottom');
        }
    }

    /**
     * Закрываем список
     */
    _closeDropdown() {
        this.isVisible = false;
        this.dropdown.classList.remove('is-visible');
        this.dropdown.classList.remove('is-bottom');
        document.removeEventListener('click', this.bindedClose, false);
    }
}

export default Stock;
